/** 对齐 spikex-ai-web /search PAGES — 映射到本项目已有路由 */
export function buildSearchPages(getUrl) {
  return [
    { label: "Markets", href: getUrl("/market") },
    { label: "AI Lab", href: getUrl("/aicopy") },
    { label: "Rewards", href: getUrl("/referral") },
    { label: "Deposit", href: getUrl("/wallet/account/common/deposit") },
    { label: "Assets Overview", href: getUrl("/wallet/account/overview") },
    { label: "Login", href: getUrl("/accounts/login") },
    { label: "Register", href: getUrl("/accounts/register") },
    { label: "Convert", href: getUrl("/convert/buy") },
    { label: "Futures", href: getUrl("/futures/contract/btc_usdt_cfd") },
  ];
}
